import { useState } from 'react';
import AdminMistakeService from './AdminMistakeService';

function useManageAdminMistakes() {
    const [mistakes, setMistakes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshMistakes = async (params = {}) => {
        setIsLoading(true);
        try {
            const response = await AdminMistakeService.getAdminMistakes(params);
            setMistakes(response.data || []);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addMistake = async (data) => {
        let result = true;
        setIsLoading(true);
        try {
            await AdminMistakeService.addAdminMistake(data);
            await refreshMistakes();
        } catch (err) {
            result = false;
            setError(err.response?.data?.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result;
    };

    const editMistake = async (mistakeId, data) => {
        setIsLoading(true);
        try {
            await AdminMistakeService.editAdminMistake(mistakeId, data);
            await refreshMistakes();
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const deleteMistake = async (mistakeId) => {
        setIsLoading(true);
        try {
            await AdminMistakeService.deleteAdminMistake(mistakeId);
            await refreshMistakes();
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        mistakes,
        isLoading,
        error,
        addMistake,
        editMistake,
        deleteMistake,
        refreshMistakes
    };
}

export default useManageAdminMistakes;
